export default __webpack_public_path__ + "static/media/pkb-7.8d597581.png";